import { Assets } from "../Assets";
import { LevelObject } from "../LevelObject";
import { Obstacle } from "../components/Obstacle";
import { dirRotation } from "../Direction";
export class Bench extends Obstacle(LevelObject) {
    constructor(levelMap, position, dir) {
        super(levelMap, Assets.objects.Bench.clone(), position);
        this.model.quaternion.copy(dirRotation(dir));
        this.shelfHeight = 0.7;
    }
    static get type() {
        return 'bench';
    }
}
